import { ReactNode } from 'react';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from './store';
import { VsAssociateEvent } from '../model';

export type NotificationSeverity = 'error' | 'info' | 'success' | 'warning';

interface AssociateEventsState {
  currentIncomingConversationRequestEvent?: VsAssociateEvent;
}

const initialState: AssociateEventsState = {
  currentIncomingConversationRequestEvent: undefined,
};

export const associateEventsSlice = createSlice({
  name: 'associateEvents',
  initialState,
  reducers: {
    setCurrentIncomingConversationRequestEvent: (
      state,
      action: PayloadAction<VsAssociateEvent | undefined>,
    ) => {
      state.currentIncomingConversationRequestEvent = action.payload;
    },
  },
});

export const selectCurrentIncomingConversationRequestEvent = (state: RootState) =>
  state.associateEvents.currentIncomingConversationRequestEvent;

export default associateEventsSlice.reducer;
